import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";

export class Treatment extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      Sn: "",
      Route: "",
      DrugName: "",
      Dosage: "",
      Frequency: "",
      Duration: "",
      DrugAdministration: "",
      loading:false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    console.log(localStorage.getItem("currentVisitId"));

    event.preventDefault();
    var dict = {
      Route: this.state.tablevaluesglobal["Route"],
      DrugName: this.state.tablevaluesglobal["DrugName"],
      Dosage: this.state.tablevaluesglobal["Dosage"],
      Frequency: this.state.tablevaluesglobal["Frequency"],
      Duration: this.state.tablevaluesglobal["Duration"],
      DrugAdministration: this.state.tablevaluesglobal["DrugAdministration"],
      midwifenursename: this.state.tablevaluesglobal["midwifenursename"],
      remarks: this.state.tablevaluesglobal["remarks"],
    };
    this.setState({
      loading: true
    })
    axios
      .post(
        this.api_url+"" +
          localStorage.getItem("currentModule") +
          "/treatment/main",
        dict,
        { headers: headers }
      )
      .then((response) => {
        this.setState({
          loading: false
        })

        if (response.data == "No results found") {
          $(".noResultsFound").show();
          $(".resultDisplay").hide();
        } else {
          $(".noResultsFound").hide();
          $(".alert-success").show();

          setTimeout(function () {
            window.location.href = '/triage/admission/triage'
          }, 500);
          // console.log(response)resultDisplay
          //
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  handleTableChange(event) {
    console.log(event);
    this.setState({ myParentTrigger: this.state.myParentTrigger + "a" });
  }

  getTableValues(event) {
    var data = event;
    let topobj = {};
    let tableobj = {};
    // console.log(event.length)
    // var data = event.
    // for (let i = 0; i < data.length; i++) {
    //     let trim = data[i];
    let trimobj = {};
    this.setState({
      Year: "1212",
    });
    console.log(data[0]);

    trimobj.Route = data[0][0];
    trimobj.DrugName = data[0][1];
    trimobj.Dosage = data[0][2];
    trimobj.Frequency = data[0][3];
    trimobj.Duration = data[0][4];
    trimobj.DrugAdministration = data[0][5];
    trimobj.midwifenursename = data[0][6];
    trimobj.remarks = data[0][7];

    tableobj = trimobj;
    topobj.prepplan = tableobj;
    // }
    this.state.tablevaluesglobal = topobj["prepplan"];
    console.log(this.state.tablevaluesglobal);
    // let tablevalues = this.formatTableOutput(event);
    // console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["", "", "", "", "", "", "", "", localStorage.getItem("Currentusername")],
    ];

    const columns = [
      "Route",
      "Drug Name",
      "Dosage",
      "Frequency",
      "Duration",
      "Drug Administration Date Time Given",
      "Name of Midwife/Nurse",
      "Doctor`s Remarks",
      "Name of Doctor",
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}
    const {loading} = this.state
    return (
      <div>
        <Headers />
        <InterModularSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Treatment
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="#editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details Saved Successfully.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                  {loading ? 'Loading' : 'Submit'}  
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default Treatment;
